angular.module('pe4h').controller('FooterController', function($scope) {
	$scope.year = new Date().getFullYear();
});